
import { defineComponent, ref, onMounted } from "vue";
import ApiService from "@/core/services/ApiService";
import { useStore } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { Modal } from "bootstrap";

import AddApplicationModal from "@/components/modals/general/AddApplicationModal.vue";
import AdminApplicationDrawer from "@/layout/extras/AdminApplicationDrawer.vue";
import { DrawerComponent } from "@/assets/ts/components/_DrawerComponent";
import SmsMessageModal from "@/components/modals/general/SmsMessageModal.vue";
import IboEmailModal from "@/components/modals/general/IboEmailModal.vue";

export default defineComponent({
  name: "admin-tasks",
  emits: ["submit"],

  components: {
    AddApplicationModal,
    AdminApplicationDrawer,
    SmsMessageModal,
    IboEmailModal,
  },
  props: {
    widgetClasses: String,
  },
  setup(props, { emit }) {
    const applicationFileListTotal = ref(0);
    const applicationFileList = ref([]);
    const applicationCenterListTotal = ref(0);
    const applicationCenterList = ref([]);
    const store = useStore();
    const loading = ref(false);
    const fileDeleteLoading = ref(false);

    onMounted(async () => {
      setTimeout(async () => {
        await getApplicationCenterList();
        DrawerComponent.reinitialization();
      }, 1000);
    });
    const getApplicationCenterList = async () => {
      loading.value = true;
      const res2 = await ApiService.get(
        `users/app.center?admin_id=${store.getters.currentUser.data.adminid}`
      );
      applicationCenterList.value = res2.data.data;
      applicationCenterListTotal.value = res2.data.meta.total;

      loading.value = false;
    };
    const getApplicationFileList = async (val) => {
      loading.value = true;
      const res2 = await ApiService.get(`img/ibo_files?app_id=${val}`);
      applicationFileList.value = res2.data.data;
      applicationFileListTotal.value = res2.data.meta.total;

      loading.value = false;
    };
    const checked = ref(false);

    const submit = async (index, status, text, color) => {
      let payload: any = "";
      loading.value = true;
      try {
        const res = await ApiService.put(
          `img/ibo_files/${index}?reviewed=1&status=${status}&text=${text}&color=${color}`,
          payload
        );
        if (res.data.success) {
          Swal.fire({
            text: "Document Reviewed!",
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-primary",
            },
          }).then(function () {
            getApplicationCenterList();
          });
        } else {
          Swal.fire({
            text: res.data.error.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Try again!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        }
      } catch (e) {
        Swal.fire({
          text: e.response.data.error
            ? e.response.data.error.message
            : "Something went wrong!",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Try again!",
          customClass: {
            confirmButton: "btn fw-bold btn-light-danger",
          },
        });
      }
      loading.value = false;
    };
    const selectedMerchant = ref({});

    const openDrawer = (val) => {
      selectedMerchant.value = val;
      DrawerComponent?.getInstance("admin_application_drawer")?.show();
    };

    const openEmailModal = (val) => {
      selectedMerchant.value = val;
      var emailModal = new Modal(
        document.getElementById("modal_email_message"),
        {}
      );
      emailModal.show();
    };

    const openSmsModal = (val) => {
      selectedMerchant.value = val;
      var smsModal = new Modal(
        document.getElementById("modal_sms_message"),
        {}
      );
      smsModal.show();
    };

    const onDeleteApplication = async (index) => {
      fileDeleteLoading.value = true;
      try {
        const res = await ApiService.delete(`users/ibos_applications/${index}`); //app_id
        if (res.data.success) {
          Swal.fire({
            text: "Application Deleted!",
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-primary",
            },
          }).then(function () {
            getApplicationCenterList();
            emit("submit");
          });
        } else {
          Swal.fire({
            text: res.data.error.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Try again!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        }
      } catch (e) {
        Swal.fire({
          text: e.response.data.error
            ? e.response.data.error.message
            : "Something went wrong!",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Try again!",
          customClass: {
            confirmButton: "btn fw-bold btn-light-danger",
          },
        });
      }
      fileDeleteLoading.value = false;
    };
    const onUpdateIboApplication = () => {
      getApplicationCenterList();
    };

    return {
      openDrawer,
      openEmailModal,
      openSmsModal,
      onDeleteApplication,

      submit,
      getApplicationCenterList,
      getApplicationFileList,
      applicationCenterList,
      applicationCenterListTotal,
      applicationFileList,
      applicationFileListTotal,
      checked,
      selectedMerchant,
      onUpdateIboApplication,
    };
  },
});
